<template>
	<div class="trainer-card text-left max-w-sm w-full flex flex-col">
		<div
			class="relative bg-primary-100 rounded-3xl overflow-hidden w-full max-w-[342px] lg:max-w-full mx-auto h-[187px] sm:w-[400px] sm:h-[310px]"
		>
			<img
				class="grayscale w-auto h-[225px] sm:h-[400px] absolute left-0 right-0 sm:left-0 bottom-[-36%] mx-auto object-cover"
				:src="image"
				:alt="description"
				width="374"
				height="400"
				loading="lazy"
			/>
		</div>
		<div class="flex-grow py-6 flex flex-col justify-between">
			<div>
				<h3 class="text-white text-3xl font-bold mb-4">{{ title }}</h3>
				<p class="text-white text-lg">{{ description }}</p>
			</div>
		</div>

		<LinkWithArrow
			class="!mt-0"
			label="Learn More"
			:link="link"
		/>
	</div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
	title: String,
	description: String,
	image: String,
	link: String
});
</script>

<style lang="scss" scoped>
@media (max-width: 1215px) {
	.trainer-card {
		text-align: center;
		.trainer-btn {
			align-self: center;
		}
	}
}

.grayscale {
	filter: grayscale(100%);
}
</style>
